"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transactionStatus = exports.paymentGateway = void 0;
const Purchase_1 = require("./Purchase");
exports.paymentGateway = ['payless', ...Purchase_1.paymentsGateways];
exports.transactionStatus = ['created', 'pending', 'completed', 'refunded'];
